<template>
  <div>
    <div class="section1 safe-area">
      <pageTitle cn="参赛准入标准" en="Entry Qualification Rules" type="1"></pageTitle>
      <div class="imgs">
        <div class="img-item">
          <div class="tit">
            <div class="cn">组队形式</div>
            <div class="en">Team Formation</div>
          </div>
          <img :src="$env.imgUrl + 'pbl3-s1-1.png?v=0720'" alt="">
        </div>
        <div class="img-item">
          <div class="tit">
            <div class="cn">角色分配</div>
            <div class="en">Role Assignment</div>
          </div>
          <img :src="$env.imgUrl + 'pbl3-s1-2.png?v=0720'" alt="">
        </div>
        <div class="img-item">
          <div class="tit">
            <div class="cn">队员条件</div>
            <div class="en">Member Requirements</div>
          </div>
          <img :src="$env.imgUrl + 'pbl3-s1-3.png?v=0720'" alt="">
        </div>
      </div>
    </div>
    <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-2.png);'">
      <div class="safe-area">
        <pageTitle cn="六大队内分工" en="Six Team Roles" type="2"></pageTitle>
        <el-row :gutter="30" class="mt-40">
          <el-col :span="12" v-for="(item, index) in list" :key="index">
            <div class="page-flex-lr-center list-item">
              <div class="lf page-flex-lr-center">
                <img :src="$env.imgUrl + 'pbl3-s2-'+ (index + 1) +'.png'" alt="">
              </div>
              <div class="rt page-flex-lr-center">
                <div class="title">
                  <div class="cn">{{ item.title }}</div>
                  <div class="en">{{ item.enTitle }}</div>
                </div>
                <div class="desc">
                  <div class="cn">{{ item.desc }}</div>
                  <div class="en">{{ item.enDesc }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [
        {
          title: '队长',
          enTitle: 'Team Leader',
          desc: '统筹全队任务分配、进度协调、团队管理',
          enDesc: 'Oversees task allocation, schedule coordination, and team management'
        },
        {
          title: '作家',
          enTitle: 'Writer',
          desc: '撰写调研报告、PPT文稿、舞台剧完整剧本',
          enDesc: 'Drafts research reports, PPT content, and the full stage play script'
        },
        {
          title: '演说家',
          enTitle: 'Speaker',
          desc: '负责总决赛双语路演、评委问答环节',
          enDesc: 'Handles bilingual pitch presentations and Q&A with judges in the finals'
        },
        {
          title: '艺人',
          enTitle: 'Performer',
          desc: '舞台剧总策划、主演，统筹舞台编排与视觉呈现',
          enDesc: 'Chief planner and lead actor of the stage play, overseeing staging and visual presentation'
        },
        {
          title: '匠人',
          enTitle: 'Craftsman',
          desc: '全权负责工程手作、舞台道具、展览装置制作',
          enDesc: 'Takes full charge of handmade engineering, stage props, and exhibition installation'
        },
        {
          title: '外交官',
          enTitle: 'Diplomat',
          desc: '负责跨队伍交流、嘉年华互动、晚宴对外沟通',
          enDesc: 'Manages cross-team communication, carnival interactions, and external liaison at banquets'
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.d5{
  color: #000;
  font-family: systh;
  font-size: 26px;
  margin-top: 14px;
  margin-bottom: 20px;
}
.mt-20{
  margin-top: 20px;
}
.mt-40{
  margin-top: 40px;
}
.section1{
  padding-top: 30px;
  .imgs{
    display: flex;
    justify-content: space-between;
    .img-item{
      width: 33%;
      padding: 20px;
      box-sizing: border-box;
      text-align: center;
      border-right: 1px dashed #999;
      &:last-child{
        border-right: none;
      }
      .tit{
        margin-bottom: 10px;
        .cn{
          font-size: 16px;
          font-family: systh;
          color: #000;
        }
        .en{
          font-size: 10px;
          font-family: systm;
          color: #666;
        }
      }
      img{
        width: 100%;
      }
    }
  }
}
.section2{
  padding: 120px 0 40px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.list-item{
  height: 80px;
  margin-bottom: 20px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
  border-radius: 14px;
  .lf{
    width: 140px;
    height: 80px;
    background-color: #000;
    border-radius: 14px 0 0 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      height: 40px;
    }
  }
  .rt{
    flex: 1;
    background-color: #fff;
    padding: 0 20px;
    height: 100%;
    border-radius: 0 14px 14px 0;
    .title{
      border-left: 4px solid #C9273A;
      width: 64px;
      padding-left: 6px;
      .cn{
        font-size: 16px;
        font-family: systh;
        color: #000;
      }
      .en{
        font-size: 8px;
        font-family: systm;
        color: #666;
      }
    }
    .desc{
      flex: 1;
      .cn{
        font-size: 12px;
        color: #333;
        font-family: systm;
      }
      .en{
        font-size: 8px;
        color: #999;
        font-family: systm;
      }
    }
  }
}
</style>
